import React, { Component } from 'react';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import { Row, Col, Button } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import moment from "moment";
import { subDays } from 'date-fns';
export default class RawDataSearchFile extends Component {
  constructor(props){
    super(props)
    this.state= {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      selectedDump:[],
    }
  }
  componentWillMount = () => {  
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.filter(inventory);
      this.setState({selectedregionName:regionNames[0]})
    }    
  }
  regionNames = () => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
     let regionNames = _.filter(inventory);
      return regionNames;
    }    
  }
  centerNames = () => {
    const{selectedregionName} = this.state;
    if(!_.isEmpty(selectedregionName)){
      let centerName = selectedregionName.userCenters
      return centerName;
    }
    
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    if(!_.isEmpty(selectedcenterName)){
      let clientName = selectedcenterName.userClients 
      return clientName;
    }
  }
  processNames = () => {
    const{selectedclientName} = this.state;    
    if(!_.isEmpty(selectedclientName)){
      let processName = selectedclientName.userProcesses 
      return processName;
    }
  }
  
  
  handleSelect = (e) => {
    this.setState({selectedregionName: e});
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[]
      })
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedclientName:[], selectedprocessName:[]})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[]})
    }
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});  
  }
  handleChangeStart = (date) => {
   // date.setMinutes( date.getMinutes() + date.getTimezoneOffset() );
    this.setState({startDate: date});
  }
  // handleChangeEnd = (e) => {
  //  // e.setMinutes( e.getMinutes() + e.getTimezoneOffset() );
  //   this.setState({endDate: e});
  // }
  // handleChange = (e) =>{
  //   this.setState({phone:e.target.value})
  // }
  handleDump = (e) =>{
    this.setState({selectedDump: e})
  }
  rawdataSearch = () =>{
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, selectedDump, startDate} = this.state   
    let obj ={
      'region':{"regionName":selectedregionName.inventoryRegionName, 'regionId':selectedregionName.inventoryRegionId},
      "center":{'centerId':selectedcenterName.inventoryCenterId, 'centerName':selectedcenterName.inventoryCenterName},
      "client":{'clientId':selectedclientName.inventoryClientId, 'clientName':selectedclientName.inventoryClientName},
      "process":{'processId':selectedprocessName.inventoryProcessId, 'processName':selectedprocessName.inventoryProcessName},      
      "startDate":moment(startDate).format('YYYY-MM-DD')
    }
    var date = moment(startDate).format('YYYY-MM-DD')
   // var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    //var today = new Date()
   //var date = today.getDate() +  '-' + months[today.getMonth()] + '-' + today.getFullYear();
   // var time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    if(selectedDump === 'ALL')  {
      this.props.action.downLoadRawDataDump(obj, 'CSAT_DUMP_'+this.props.loginAction.userName+'_'+date+'.xlsx')
      this.props.action.downLoadRawDataDumpCompliance(obj,'COMPLIANCE_DUMP_'+this.props.loginAction.userName+'_'+date+'.xlsx')
      this.props.action.downLoadRawDataDumpTransact(obj, 'TRANSACTIONAL_DUMP_'+this.props.loginAction.userName+'_'+date+'.xlsx')
    } else if(selectedDump === 'TRANSACTIONAL') {
      this.props.action.downLoadRawDataDumpTransact(obj, 'TRANSACTIONAL_DUMP_'+this.props.loginAction.userName+'_'+date+'.xlsx')
    } else if(selectedDump === 'CSAT') {
      this.props.action.downLoadRawDataDump(obj,'CSAT_DUMP_'+this.props.loginAction.userName+'_'+date+'.xlsx')
    } else if(selectedDump === 'COMPLIANCE') {
      this.props.action.downLoadRawDataDumpCompliance(obj, 'COMPLIANCE_DUMP_'+this.props.loginAction.userName+'_'+date+'.xlsx')
    }  else if(selectedDump === 'CLI DATA') {
      this.props.action.downLoadRawDataDumpcli(obj, 'CLI_DUMP_'+this.props.loginAction.userName+'_'+date+'.xlsx')
    }  else if(selectedDump === 'CRM DATA') {
      this.props.action.downLoadRawDataDumpcrm(obj, 'CRM_DUMP_'+this.props.loginAction.userName+'_'+date+'.xlsx')
    }
    
  }
  render(){
    return(
    <div>
      <Row>
      <Col>
        <label>Region Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedregionName}
        options={this.regionNames()}
        onChange={this.handleSelect}
        open={false}
        valueKey="inventoryRegionName"
        labelKey="inventoryRegionName"
        multiple={false}
        includeSelectAll={false}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select Region'
        dropdownHeight={600}
      />
      </Col>
    </Row> 
      <Row>
      <Col>
        <label>Center Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedcenterName}
        options={this.centerNames()}
        onChange={this.handleSelectCenter}
        open={false}
        valueKey="inventoryCenterName"
        labelKey="inventoryCenterName"
        multiple={false}
        includeSelectAll={false}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select Center'
        dropdownHeight={600}
      />
      </Col>             
    </Row>
      <Row>
      <Col>
        <label>Client Name</label>
      </Col>
      <Col>
    <Picky keepOpen={false}
      value={this.state.selectedclientName}
      options={this.clientNames()}
      onChange={this.handleSelectClient}
      open={false}
      valueKey="inventoryClientName"
      labelKey="inventoryClientName"
      multiple={false}
      includeSelectAll={false}
      includeFilter={true}
      clearFilterOnClose={true}
      placeholder='Select Client'
      dropdownHeight={600}
    />
    </Col>
    </Row> 
      <Row>
      <Col>
      <label>Process Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
      value={this.state.selectedprocessName}
      options={this.processNames()}
      onChange={this.handleSelectProcess}
      open={false}
      valueKey="inventoryProcessName"
      labelKey="inventoryProcessName"
      multiple={false}
      includeSelectAll={false}
      includeFilter={true}
      clearFilterOnClose={true}
      placeholder='Select Process Name'
      dropdownHeight={600}
    />
     </Col>
     </Row>
     <Row>
      <Col>
      <label>Dump For</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
      value={this.state.selectedDump}
      options={['TRANSACTIONAL', 'CSAT', 'COMPLIANCE', 'CLI DATA', 'CRM DATA']}
      onChange={this.handleDump}
      open={false}
     // valueKey="inventoryProcessName"
     // labelKey="inventoryProcessName"
      multiple={false}
      includeSelectAll={false}
      includeFilter={false}
      placeholder='Select Dump Type'
      dropdownHeight={600}
    />
     </Col>
     </Row>      
      <Row className='marginBottom'>
        <Col>
        <label>Date</label> 
       </Col>
        <Col className=''>
        <DatePicker
           selected={this.state.startDate}
           className='myDatePicker'
           selectsStart
           showMonthDropdown
           startDate={this.state.startDate}
           onChange={this.handleChangeStart}
           minDate={subDays(new Date(), 59)}
           maxDate={new Date()}
           placeholderText="Select date"
          />
        {/* <DatePicker
        
          selected={this.state.endDate}
          selectsEnd
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onChange={this.handleChangeEnd}
          minDate={this.state.startDate}
         // maxDate={addDays(this.state.startDate, 10)}
          placeholderText="Select a date Range"
          />     */}
       </Col> 
     </Row> 
  
    <center>
      <Button className='buttonwidth' onClick={this.rawdataSearch}>Download</Button></center>
    </div>)
  }
}